// extracted by mini-css-extract-plugin
export default {"menuBlock":"cF-z","title":"dF-z","nav":"eF-z","flexCell":"fF-z","facetLink":"gF-z"};